// AppLayout.jsx
// Client: vmfive
// Version: 1.0.0
// Product: Ad SaaS — Dashboard shell with sidebar + header + content area

import React, { useState, createContext, useContext } from 'react';
import './AppLayout.css';

const LayoutContext = createContext({
  sidebarCollapsed: false,
  sidebarOpen: false,
  toggleSidebar: () => {},
  openSidebar: () => {},
  closeSidebar: () => {},
});

export function useLayout() {
  return useContext(LayoutContext);
}

export default function AppLayout({
  sidebar,
  header,
  children,
  className = '',
}) {
  // collapsed = tablet icon-only mode (user toggle or auto via CSS)
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  // open = mobile drawer open
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const ctx = {
    sidebarCollapsed,
    sidebarOpen,
    toggleSidebar: () => setSidebarCollapsed((v) => !v),
    openSidebar: () => setSidebarOpen(true),
    closeSidebar: () => setSidebarOpen(false),
  };

  return (
    <LayoutContext.Provider value={ctx}>
      <div
        className={[
          'app-layout',
          sidebarCollapsed ? 'app-layout--collapsed' : '',
          className,
        ]
          .filter(Boolean)
          .join(' ')}
      >
        {/* Mobile overlay */}
        {sidebarOpen && (
          <div
            className="app-layout__overlay"
            onClick={() => setSidebarOpen(false)}
          />
        )}

        {/* Sidebar */}
        <aside
          className={[
            'app-layout__sidebar',
            sidebarOpen ? 'app-layout__sidebar--open' : '',
          ]
            .filter(Boolean)
            .join(' ')}
        >
          {sidebar}
        </aside>

        {/* Main area */}
        <div className="app-layout__main">
          {/* Header */}
          <header className="app-layout__header">
            <button
              className="app-layout__menu-btn"
              onClick={() => {
                // Mobile: open drawer; Desktop: toggle collapse
                if (window.innerWidth < 768) {
                  setSidebarOpen(true);
                } else {
                  setSidebarCollapsed((v) => !v);
                }
              }}
              aria-label="Toggle sidebar"
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 5h14M3 10h14M3 15h14" />
              </svg>
            </button>
            {header}
          </header>

          {/* Content */}
          <div className="app-layout__content">{children}</div>
        </div>
      </div>
    </LayoutContext.Provider>
  );
}
